"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _class, _temp;

var Blink = (0, _mobxReact.observer)(_class = (_temp =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Blink, _Component);

  function Blink(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.blinkInterval = void 0;
    _this.state = {
      showChild: true
    };
    return _this;
  }

  var _proto = Blink.prototype;

  _proto.startBlink = function startBlink() {
    var _this2 = this; // Toggle the display state


    this.blinkInterval = setInterval(function () {
      _this2.setState(function (previousState) {
        return {
          showChild: !previousState.showChild
        };
      });
    }, 500);
  };

  _proto.stopBlink = function stopBlink() {
    clearInterval(this.blinkInterval);
  };

  _proto.componentDidMount = function componentDidMount() {
    this.startBlink();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.stopBlink();
  };

  _proto.render = function render() {
    return _react.default.createElement("span", {
      style: {
        visibility: this.state.showChild ? "visible" : "hidden"
      }
    }, this.props.children);
  };

  return Blink;
}(_react.Component), _temp)) || _class;

exports.default = Blink;